import * as api from "@/api/williams/scopesOfWork";
import { ScopeOfWork } from "@/api/williams/scopesOfWork";
import { useMutation } from "react-query";

export function useWelderAdvisories() {
  return useMutation(async (scope: ScopeOfWork) => {
    scope.reportDate = new Date().toISOString().substring(0, 10);

    if (scope.welders) {
      const promises = scope.welders.map(async (welder) => {
        welder.advisories = await api.gethWelderAdvisories(scope, welder);
      });

      await Promise.all(promises);
      return scope;
    }
  });
}
